/* eslint-disable @reatom/unit-naming-rule */
import { action } from '@reatom/framework'

import { selectedNetworkAtom } from '@root/entities/network'
import { reatomRequest } from '@root/shared/lib'

import { userCheckInviterRequestAction } from './referral-code-requests'

import type { InviteCode } from '@root/entities/referral'

export const reatomGetInviter = () => {
  const getInviterRequestAtom = reatomRequest({
    execAction: action(
      async (
        ctx,
        req: {
          inviteCode: InviteCode
        },
      ) => {
        const result = await ctx.schedule(() =>
          userCheckInviterRequestAction(ctx, {
            ...req,
            network: ctx.get(selectedNetworkAtom),
          }),
        )

        return result
      },
      'getInviterRequestAtom.execAction',
    ),
  })

  return {
    getInviterState: getInviterRequestAtom,
    getInviter: getInviterRequestAtom.execute,
  }
}
